import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'table': 'String!',
	'table_key': 'String!',
	'field': 'String!',
	'content': 'String!',
	'language_code': 'String!',
};

export default gql(`
	mutation translation( ${ HelperGraphql.createFields( fields ) } ) {
	    translation( ${ HelperGraphql.createVariables( fields ) } ) {
	        field
	        title
	        description
        
            language {
                guid
                code
            }
	    }
	}
`);

